/**
 * CaseSection displays help messages for the user having active case in the resolution center
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import l10n from '../../lib/reactPPl10nHelper';
import { trackPage, trackLink } from '../../lib/analytics-helper';
import * as homeShape from '../constants/PropTypesShapes';
import Page from '../../lib/page';
import { elmoTreatmentNames, isPartOfElmoExpTreatment } from '../../lib/experiments-helper';

const dataSet = {
  dispute: {
    checkMessage: l10n.getContent('smarthelp/info.info.casesection.dispute.checkMessage'),
    label: l10n.getContent('smarthelp/info.info.casesection.dispute.ResolutionLink'),
    link: 'https://www.msmaster.qa.paypal.com/disputes/',
    case: l10n.getContent('disputeHelp/disputeHelp.dispute.transactions.case'),
    reason: l10n.getContent('disputeHelp/disputeHelp.dispute.transactions.reason'),
    updated: l10n.getContent('disputeHelp/disputeHelp.dispute.transactions.updated'),
    amount: l10n.getContent('disputeHelp/disputeHelp.dispute.transactions.amount'),
    status: l10n.getContent('disputeHelp/disputeHelp.dispute.transactions.status'),
    action: l10n.getContent('disputeHelp/disputeHelp.dispute.transactions.action'),
    view: l10n.getContent('disputeHelp/disputeHelp.dispute.transactions.view'),
  },
  fptiEvent: {
    click: 'clicked',
    open: 'open',
  },
};

class CaseSection extends Component {
  // Send FPTI for dispute section for both case-section open and clicked
  static FPTIHandler() {
    trackPage({ id: 'articlePage', link: 'smarthelp-disputes' });
  }

  static renderResolutionLink() {
    return (<a
      className="dispute-message-link"
      onClick={() => CaseSection.FPTIHandler(dataSet.fptiEvent.click)}
      href={dataSet.dispute.link}
      rel="noopener noreferrer"
      target="_blank"
    >{dataSet.dispute.label}</a>);
  }

  static disputeSelected(disputeId) {
    trackLink({ id: 'articlePage', link: `dispute-${disputeId}|click`, name: Page.getPageName() });
  }

  static DisputeRows(transactions) {
    return (transactions.map(dispute => (
      <tr id="dispute-row" className="dispute-transaction">
        <td><span>
          <a
            href={`/resolutioncenter/${dispute.id}`} onClick={() => CaseSection.disputeSelected(dispute.id)}
          >{dispute.id}</a></span></td>
        <td><span>{dispute.reason_code}</span></td>
        <td><span>{CaseSection.dateCovertor(dispute.last_updated_timestamp)}</span></td>
        <td><span>{dispute.amount.value}</span></td>
        <td><span>{dispute.status}</span></td>
        <td><a
          href={`/resolutioncenter/${dispute.id}`} onClick={() => CaseSection.disputeSelected(dispute.id)} className="view-dispute-btn Button Button--secondary Button--md"
        >{dataSet.dispute.view}</a></td>
      </tr>
    )));
  }

  static renderOldDisputeMsg() {
    const disputeViewMsg = l10n.getContent('smarthelp/info.info.casesection.dispute.viewCase',
      { ViewResolution: CaseSection.renderResolutionLink() });
    return (
      <div className="dispute-message-container">
        <span className="dispute-message-checker">{dataSet.dispute.checkMessage}</span>
        <span className="dispute-message-view">{disputeViewMsg}</span>
      </div>);
  }

  static dateCovertor(updatedDate) {
    const convertedDate = new Date(updatedDate);
    return convertedDate.toDateString();
  }

  // return true, when the login user have resolution center open cases
  isOpenCase() {
    // checking for faqs in dispute faq remote config
    const isDisputeFAQ = Page.disputeArticle(this.props.articleId);

    // checking for breadcrumb path in dispute breadcrumb remote config
    const isDisputeBreadCrumb = Page.disputeBreadCrumb(this.props.articleBreadCrumb);

    return Array.isArray(this.props.cases) && this.props.cases.length > 0 && (isDisputeFAQ || isDisputeBreadCrumb);
  }

  disputeTransaction() {
    const { elmoTreatment, receivedResponse } = this.props;
    const elmoResource = isPartOfElmoExpTreatment(elmoTreatment, elmoTreatmentNames.pendingDisputesNotification);
    if (elmoResource) {
      // If elmo-resource exists then render the UI
      CaseSection.FPTIHandler(dataSet.fptiEvent.open);
      return this.renderDisputeMsg();
    } else if (!receivedResponse && !elmoResource) {
      // If elmo-resource API response is received and no elmo resource exists, render existing function
      CaseSection.FPTIHandler(dataSet.fptiEvent.open);
      return CaseSection.renderOldDisputeMsg();
    }
    return null;
  }

  renderDisputeMsg() {
    // changed view to translations
    const { cases } = this.props;
    return (
      <div className="dispute-message-container">
        <thead>
          <tr>
            <th className="text-center" scope="col">{dataSet.dispute.case}</th>
            <th className="text-center" scope="col">{dataSet.dispute.reason}</th>
            <th className="text-center" scope="col">{dataSet.dispute.updated}</th>
            <th className="text-center" scope="col">{dataSet.dispute.amount}</th>
            <th className="text-center" scope="col">{dataSet.dispute.status}</th>
            <th className="text-center" scope="col">{dataSet.dispute.action}</th>
          </tr>
        </thead>
        <tbody>
          {CaseSection.DisputeRows(cases)}
        </tbody>
      </div>
    );
  }


  render() {
    if (!this.isOpenCase()) {
      return null;
    }
    return (
      <div className="case-section-container">
        {this.disputeTransaction()}
      </div>
    );
  }
}

CaseSection.propTypes = {
  articleId: PropTypes.string,
  articleBreadCrumb: PropTypes.string,
  cases: PropTypes.shape(homeShape.OPEN_CASE),
  elmoTreatment: PropTypes.shape(homeShape.ELMO_TREATMENT),
  receivedResponse: PropTypes.bool.isRequired,
};

CaseSection.defaultProps = {
  articleId: '',
  articleBreadCrumb: '',
  cases: [],
  elmoTreatment: [],
};

export default CaseSection;
